import { render, staticRenderFns } from "./MessageOfTheDay.vue?vue&type=template&id=69ef3206"
import script from "./MessageOfTheDay.vue?vue&type=script&lang=js"
export * from "./MessageOfTheDay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports